import { render, staticRenderFns } from "./AlbumPhotoBody.vue?vue&type=template&id=d56e4828&"
import script from "./AlbumPhotoBody.vue?vue&type=script&lang=js&"
export * from "./AlbumPhotoBody.vue?vue&type=script&lang=js&"
import style0 from "./AlbumPhotoBody.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d56e4828')) {
      api.createRecord('d56e4828', component.options)
    } else {
      api.reload('d56e4828', component.options)
    }
    module.hot.accept("./AlbumPhotoBody.vue?vue&type=template&id=d56e4828&", function () {
      api.rerender('d56e4828', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/Organizers/AlbumPhoto/AlbumPhotoBody.vue"
export default component.exports